module.exports = __webpack_public_path__ + "img/speaker31.35430fcd.png";